import limpiarHtml from '../Compartido/limpiarHtml.js';
import { RUTA_IMATGES } from '../Compartido/contenidoCamprodon.js';

const escapa = (text) => String(text ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const fletxa = (costat) =>
    '<svg aria-hidden="true" focusable="false" class="c-icon" width="37" height="11"><use href="' + RUTA_IMATGES + 'icons-sprite.svg#sprite-icon-arrow-slider-' + costat + '"></use></svg>';

// Llista d'habitacions de la pàgina Habitacions amb les propietats destacades
// de la web (PaginasController::propiedadesDestacadas): el mateix HTML que les
// targetes de l'original, que s'afegeix al contingut de la pàgina perquè el
// slider de fotos (data-slider) i els textos (data-t) els faci ContenidoHtml.
const htmlHabitaciones = (habitaciones, ruta, lang, rutaFitxa) => {
    if (!habitaciones || habitaciones.length === 0) return "";

    const targetes = habitaciones.map((propiedad, index) => {
        const fotos = propiedad.fotos_web && propiedad.fotos_web.length > 0 ? propiedad.fotos_web : [{ nombre: null }];
        const idSlider = "habitacio-fotos-" + index;
        const href = escapa(rutaFitxa(propiedad));
        const imatges = fotos.map((foto) => {
            const src = foto.nombre ? ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + foto.nombre : "/images/web/bedloop-nofoto.png";
            const alt = (foto.texto_alt && foto.texto_alt[lang]) || propiedad.nombre;
            return '<picture><img src="' + escapa(src) + '" alt="' + escapa(alt) + '" class="image-cover" width="100%" height="100%" loading="lazy" decoding="async"></picture>';
        }).join("");
        const controls = fotos.length > 1
            ? '<div data-slider="#' + idSlider + '" class="c-slider-controls c-slider-controls--white d-flex-center">'
            + '<button class="c-slider-controls__button c-slider-controls__button--prev d-flex-center" aria-label="Previous slide">' + fletxa("left") + '</button>'
            + '<button class="c-slider-controls__button d-flex-center" aria-label="Next slide">' + fletxa("right") + '</button>'
            + '<div class="c-slider-index"><span class="c-slider-index__item c-slider-index__item--current-index js-current-index">1</span>'
            + '<span class="c-slider-index__item c-slider-index__item--total-slides js-total-slides"></span></div></div>'
            : "";
        const boto = propiedad.by_request == 1 ? "Petición" : "Reservar";

        return '<article class="c-card">'
            + '<div class="c-card__header"><div class="c-slider-controls-above c-slider-controls-above--bottom-right">'
            + '<div id="' + idSlider + '">' + imatges + '</div>' + controls + '</div></div>'
            + '<div class="c-card__body"><div class="c-card__content">'
            + '<h2 class="c-card__title">' + escapa(propiedad.nombre) + '</h2>'
            + (propiedad.ladesccorta ? '<div>' + limpiarHtml(propiedad.ladesccorta) + '</div>' : "")
            + '</div><div class="c-card__footer">'
            + '<a href="' + href + '" class="c-link" data-t="Descubrir">Descubrir</a>'
            + '<a href="' + href + '" class="c-button c-button--primary c-button--large d-flex-center" data-t="' + boto + '">' + boto + '</a>'
            + '</div></div></article>';
    }).join("");

    return '<section class="rooms o-container"><div class="rooms--category c-cards-list">' + targetes + '</div></section>';
};

export default htmlHabitaciones;
